import { render, staticRenderFns } from "./UnsubscribePage.vue?vue&type=template&id=e6c19f0e&scoped=true&"
import script from "./UnsubscribePage.vue?vue&type=script&lang=js&"
export * from "./UnsubscribePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6c19f0e",
  null
  
)

export default component.exports